<template>
  <div class="contes">
    <div class="shop_list" v-for="item in NewData" :key="item._id">
      <div class="shop_wu">
        <img :src="item.imag" class="imgs" />
      </div>
      <div class="shop_wu">
        <span>创建时间:{{ item.createTime }}</span>
        <span>物品名称：{{ item.text }}</span>
        <span>物品描述：{{ item.textt }}</span>
        <span>物品规格：{{ item.specification }}</span>
        <span>断当票号：{{ item.ticketNum }}</span>
        <span>重量：{{ item.weight + "/g" }}</span>
        <span>价格：{{ item.prick + "元" }}</span>
      </div>
      <div class="shop_wu">
        <span>物品状态：</span>
        {{ item.reviewer == true ? "已复核" : "待复核" }}
      </div>
      <div class="shop_wu">
        <el-button type="primary" class="btn_bj" @click="review(item)">复核</el-button>
      </div>
    </div>

    <div class="text_title" v-if="NewData.length == 0">
      <h4>无数据</h4>
      <!-- <el-empty description="描述文字"></el-empty> -->
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "ReviewerShop",
  data() {
    return {
      NewData: [], //待复核的数据
      username: "", //当前登录的账户
    };
  },
  methods: {
    //请求待复核商品
    getReviewerData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("shop_hd").where({ismarket:true,reviewer:false}).limit(1000).get()',
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          console.log(res);
          this.NewData = res.data.data;
        });
    },
    //复核
    review(event) {
      this.$confirm(`确定要复核${event.text}，将该物品上架吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("shop_hd").doc("${event._id}").update({data:{reviewer:true}})`,
            })
            .then(() => {
              this.AddLogs(event.text, event.prick);
              this.$message({
                type: "success",
                message: "复核成功!",
              });
              setTimeout(() => {
                this.getReviewerData();
              }, 1000);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消复核",
          });
        });
    },
    //上传日志
    AddLogs(event, price) {
      this.axios.post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: `db.collection("logs").add({data:{price:"${price}",createDate:"${dayjs().format(
          "YYYY-MM-DD HH:mm:ss"
        )}",content:"${event}",action:"复核商品",username:"${this.username}"}})`,
      });
    },
  },
  created() {
    this.getTokens();
    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    setTimeout(() => {
      this.getReviewerData();
      this.username = this.userData.username;
    }, 800);
  },
};
</script>
<style scoped>
.imgs {
  width: 200px;
  height: 200px;
}
.shop_wu {
  display: flex;
  flex-direction: column;
  margin: 20px 0;
}
.shop_wu span {
  margin: 10px 0;
  font-size: 12px;
}
.shop_list {
  /* width: 90%; */
  margin: 30px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* margin: 30px 0; */
  background-color: #f7f7f7;
}
.text_title {
  text-align: center;
}
</style>
